import type { FC, Ref } from "react";

import { INDEX_NOT_FOUND } from "components/constants";
import {
  INTERACTION_MODE_CHIP_KINDS,
  INTERACTION_MODE_ICONS,
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE,
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW,
} from "components/materials/page/interaction-mode/helpers";
import { InteractionMode, PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { Chip } from "mds/components/Chip";
import { IconText } from "mds/components/IconText";
import { GROUP_INTERACTION_MODES } from "utils/page-utils";

interface StudentInteractionModeView {
  ref?: Ref<HTMLButtonElement>;
  pageGroupIndex: number;
  page: PageType;
  onPageGroupInfoCardToggle?: () => void;
}

export const StudentInteractionModeView: FC<StudentInteractionModeView> = ({
  ref,
  page,
  pageGroupIndex,
  onPageGroupInfoCardToggle,
}) => {
  if (GROUP_INTERACTION_MODES.includes(page.interaction_mode)) {
    const iconText = (
      <IconText
        containerQueryClassNameHide={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE}
        containerQueryClassNameShow={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW}
        iconStart={INTERACTION_MODE_ICONS[page.interaction_mode]}
        text={
          pageGroupIndex === INDEX_NOT_FOUND
            ? t("page_interaction_mode_menu.interaction_mode.self_assign")
            : t("common.group_title", {
                number: pageGroupIndex + 1,
              })
        }
      />
    );

    if (onPageGroupInfoCardToggle) {
      return (
        <Chip
          as="button"
          kind="hibiscus"
          ref={ref}
          title={t("tooltip.type_of_activity")}
          onClick={onPageGroupInfoCardToggle}
        >
          {iconText}
        </Chip>
      );
    }

    return <Chip kind={INTERACTION_MODE_CHIP_KINDS[page.interaction_mode]}>{iconText}</Chip>;
  }

  if (page.interaction_mode === InteractionMode.SHARED_CLASS) {
    return (
      <Chip kind={INTERACTION_MODE_CHIP_KINDS[page.interaction_mode]}>
        <IconText
          containerQueryClassNameHide={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE}
          containerQueryClassNameShow={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW}
          iconStart={INTERACTION_MODE_ICONS[page.interaction_mode]}
          shortText={t("page_interaction_mode_menu.interaction_mode.all_short")}
          text={t("page_interaction_mode_menu.interaction_mode.all")}
        />
      </Chip>
    );
  }

  if (page.interaction_mode === InteractionMode.INDIVIDUAL) {
    return (
      <Chip kind={INTERACTION_MODE_CHIP_KINDS[page.interaction_mode]}>
        <IconText
          containerQueryClassNameHide={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE}
          containerQueryClassNameShow={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW}
          iconStart={INTERACTION_MODE_ICONS[page.interaction_mode]}
          text={t("page_interaction_mode_menu.interaction_mode.individual")}
        />
      </Chip>
    );
  }

  return null;
};
